var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163f68",
    fillRule: "evenodd",
    d: "M26.872 46.42H22v-8.3h4.872v1.442h-3.078v1.822h2.864v1.442h-2.864v2.14h3.078zm3.529 0h-1.764v-8.3h4.849v1.442H30.4V41.7h2.87v1.436H30.4zm9.732-2.305a2.13 2.13 0 0 1-.825 1.771 3.63 3.63 0 0 1-2.294.647 5.475 5.475 0 0 1-2.4-.5V44.4a9.994 9.994 0 0 0 1.449.528 4.366 4.366 0 0 0 1.085.153 1.565 1.565 0 0 0 .906-.221.752.752 0 0 0 .315-.659.718.718 0 0 0-.139-.434 1.543 1.543 0 0 0-.408-.366 10.562 10.562 0 0 0-1.1-.562 5.216 5.216 0 0 1-1.163-.687 2.587 2.587 0 0 1-.619-.766 2.153 2.153 0 0 1-.231-1.022 2.127 2.127 0 0 1 .761-1.732 3.2 3.2 0 0 1 2.1-.63 5.057 5.057 0 0 1 1.258.153 8.762 8.762 0 0 1 1.253.431l-.579 1.368a8.577 8.577 0 0 0-1.12-.38 3.669 3.669 0 0 0-.871-.108 1.168 1.168 0 0 0-.781.233.762.762 0 0 0-.272.607.741.741 0 0 0 .11.406 1.2 1.2 0 0 0 .35.335 10.9 10.9 0 0 0 1.137.582 4.523 4.523 0 0 1 1.626 1.116 2.15 2.15 0 0 1 .452 1.37z",
    transform: "translate(1.467 2.533)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5498e0",
    fillRule: "evenodd",
    d: "M47 19v7.467H15V19zm-2 2.8h-2v1.867h2zm-4 0h-2v1.867h2zm-4 0h-2v1.867h2z",
    transform: "translate(1 1.267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279c5",
    fillRule: "evenodd",
    d: "M47 27v7.467H15V27zm-2 2.8h-2v1.867h2zm-4 0h-2v1.867h2zm-4 0h-2v1.867h2z",
    transform: "translate(1 1.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfsDefault);
export default __webpack_public_path__ + "static/media/efs-default.197ef3aaac0c7ef6845c73d2c991a8ce.svg";
export { ForwardRef as ReactComponent };